import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CAConstants {
  static readonly SEARCH_INPUT_MIN_LENGTH: number = 2;
  static readonly SEARCH_INPUT_DELAY: number = 500;

  static readonly TRENDS_ANALYSIS_SEARCH_DAY_LIMIT: number = 90;
}
